export default function PHP_str_word_count() {
  return (
    <div>
      <h1>PHP_str_word_count</h1>
    </div>
  );
}
